function ErrorMsg({ children }: any) {
  return <p className="text-xs text-red-600"> {children}</p>;
}

export default ErrorMsg;
